<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%; background-color: #fff">
      <policyHeader />
      <div style="overflow: hidden">
        <div class="bannerBox">
          <a-carousel :dot-position="bottom" autoplay>
            <div class="bannerImg" v-for="(item, index) in bannerData" :key="index">
              <img :src="getImg(item.imageUrl)" />
            </div>
          </a-carousel>
        </div>
        <div class="notice">
          <a-carousel dots="false" autoplay effect="fade">
            <div
              style="overflow: hidden"
              v-for="(item, index) in policyData"
              :key="index"
            >
              <div class="box">
                <div style="width: 10%">
                  <img src="@/assets/img/shuangchuangNotice.png" alt="" />
                </div>
                <a-divider style="width: 3%" type="vertical" />
                <div
                  style="width: 83%; overflow: hidden; cursor: pointer"
                  @click="onpolicyDetail(item.id)"
                  target="_blank"
                >
                  <p
                    style="
                      float: left;
                      font-size: 14px;
                      color: #999;
                      text-align: right;
                      margin-right: 20px;
                    "
                  >
                    {{ item.publishTime ? item.publishTime.split(" ")[0] : "" }}
                  </p>
                  <p
                    style="
                      float: left;
                      width: 60%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </a-carousel>
        </div>

        <div style="width: 100%; background-color: #fff">
          <div class="scDataBox">
            <div class="industrialContentBox">
              <div class="industrialContent">
                <div class="industrialContentLeft">
                  <a-carousel
                    arrows
                    autoplay
                    autoplaySpeed="50"
                    :dots="false"
                    :slides-to-show="1"
                  >
                    <template #prevArrow>
                      <div class="lef" style="display: none" />
                    </template>
                    <template #nextArrow>
                      <div class="rig" style="display: none" />
                    </template>
                    <div
                      class="imgBox"
                      style="width: 100%; height: 370px"
                      v-for="item in noticeData"
                      :key="item.id"
                    >
                      <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="" />
                      <img v-else src="@/assets/img/defaultPhotoLong.png" alt="" />
                    </div>
                  </a-carousel>
                </div>
                <div class="industrialContentRight">
                  <div class="industrialTitleBox">
                    <div class="industrialTitle">通知公告</div>
                    <div
                      class="MoreBox"
                      @click="goMore('/Innovation/components/consultation', '通知公告')"
                    >
                      更多 >
                    </div>
                  </div>
                  <a-list size="large" :data-source="noticeData">
                    <template #renderItem="{ item }">
                      <a-list-item @click="noticeDetail(item.id)">
                        <div class="left">
                          <span>{{ item.title }}</span>
                        </div>
                        <div class="right">
                          <span>
                            {{ item.publishTime ? item.publishTime.split(" ")[0] : "" }}
                          </span>
                        </div>
                      </a-list-item>
                    </template>
                  </a-list>
                </div>
              </div>
            </div>
            <div class="scDataTitle">双创数据</div>
            <!-- fourObj -->
            <div class="scDataSmallTitle">
              <div class="scDataSmallCont">
                <p class="contNum">{{ fourObj.companyCountNoOtherCount }}</p>
                <p class="contTitle">入驻企业总数</p>
              </div>
              <div class="scDataSmallCont" v-for="item in scData" :key="item.key">
                <p class="contNum">{{ item.count }}</p>
                <p class="contTitle">{{ item.title }}</p>
              </div>
              <div class="scDataSmallCont">
                <p class="contNum">{{ fourObj.baseCount }}</p>
                <p class="contTitle">基地数量</p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; background-color: #fff">
          <div id="scDataContent" class="animate__animated animate__fadeIn">
            <a-carousel
              arrows
              autoplaySpeed="40"
              :dots="false"
              style="width: 100%; margin: 0 auto"
            >
              <div>
                <div class="bigBoxBBBB">
                  <div
                    class="smallItem"
                    v-for="item in scDataInfo.slice(0, 8)"
                    :key="item.id"
                    @click="onBase(item.id)"
                  >
                    <div class="maskB"></div>
                    <div class="baseName">{{ item.baseName }}</div>
                    <div style="width: 100%; height: 300px">
                      <img
                        v-if="item.pic"
                        :src="getImg(item.pic)"
                        style="width: 100%; height: 100%"
                      />
                      <img
                        v-else
                        src="@/assets/img/defaultPhotoLong.png"
                        style="width: 100%; height: 100%"
                        alt=""
                      />
                    </div>
                    <div class="baseNameBottom">{{ item.baseName }}</div>
                  </div>
                </div>
              </div>
              <!-- <div v-for="item in scDataInfo" :key="item.id">
									<div style="width: 90%;margin: 0 auto;" @click="onBase(item.id)">
										<div style="width: 100%;height: 165px;">
											<img v-if="item.baseLogo" :src="getImg(item.baseLogo)" style="width: 100%;height: 100%;">
											<img v-else src="@/assets/img/defaultPhotoLong.png" style="width: 100%;height: 100%;" alt="">
											<p style="font-weight: bold;line-height: 42px;">
												{{ item.baseName }}
											</p>
										</div>
									</div>
								</div> -->
            </a-carousel>
          </div>
          <div class="lookBtn">
            <a-button class="btn" type="primary" @click="onBaseMore">了解更多</a-button>
          </div>
        </div>
        <!-- <div style="width: 100%;background-color: #fff;">
					<div class="activityBox">
						<div class="activityTitle">活动报名</div>
						<div class="activityContent">
							<div class="activityLi" v-for="item in activityData.slice(0, 4)" :key="item.key"
								@click="onActivery(item.id)">
								<div class="activityImg">
									<img style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
								</div>
								<div class="activityInfoTitle">
									{{ item.title }}
								</div>
								<div class="activityInfoTime">
									报名时间：{{ item.activityTime && item.activityTime.split(' ')[0] }} ~ {{
										item.signendTime && item.signendTime.split(' ')[0] }}
								</div>
								<div class="activityInfoTime">
									活动时间：{{ item.startDate && item.startDate.split(' ')[0] }} ~ {{ item.endDate && item.endDate.split(' ')[0] }}
								</div>
								<div class="activityInfoAddress">
									地址：{{ item.address }}
								</div>
							</div>
						</div>
						<div class="lookBtn">
							<a-button class="btn" type="primary" @click="onActiveryMore">了解更多</a-button>
						</div>
					</div>
				</div> -->
        <div style="width: 100%; height: 160px; background-color: #fff" @click="goDcwj()">
          <img style="width: 100%; height: 100%; cursor: pointer" src="./img/juan.jpg" />
        </div>
      </div>
    </div>
    <div class="foot">
      <div style="width: 1200px; margin: 0 auto">
        <span @click="onActiveryMore">活动报名</span>
      </div>
    </div>
    <LayoutFooter />
    <el-dialog v-model="dialogFormVisible">
      <el-form :model="form">
        <div class="suevey-div">
          <div class="suevey-content">
            <h3 class="survey-title">调查问卷</h3>
            <div class="form-container">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <!-- 问题1  -->
                <el-form-item
                  :prop="`question_${item.id}`"
                  class="form-item"
                  v-for="(item, index) in questionList"
                  :key="item.id"
                  :rules="rules[`question_${item.id}`]"
                >
                  <span class="form-label">{{ index + 1 }}、{{ item.label }}</span>
                  <el-radio-group
                    v-model="ruleForm[`question_${item.id}`]"
                    class="radio-group"
                    v-for="itemStyle in item.formItems"
                    :key="itemStyle.id"
                  >
                    <el-radio :label="itemStyle.label" class="radio-item"></el-radio>
                  </el-radio-group>
                </el-form-item>

                <!-- 按钮区域 -->
                <el-form-item class="submit-button-group">
                  <el-button type="primary" @click="submitForm('ruleForm')"
                    >立即提交</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
          </div>
        </template>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { noticeInfo } from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2";
import { activity, base, noticeWeb, policyWeb, sheetWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import policyHeader from "./components/policyHeader";
import { getBannerInfo } from "@/api/homeService";

export default {
  name: "index",
  components: {
    LayoutFooter,
    policyHeader,
  },
  data() {
    return {
      fourObj: {},
      fileLists: [],
      platformName,
      activityData: [],
      scData: [],
      scDataInfo: [],
      scDataInfoAll: [],
      bannerData: [],
      noticeData: [],
      policyData: [],
      questionList: [],
      dialogFormVisible: false,
      ruleForm: {},
      rules: {},
    };
  },
  mounted() {
    this.getFourData();
    // this.getSignup()
    this.getGather();
    this.getList();
    this.getBannerList();
    this.getNoticeData();
    this.getPolicyList();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message.success("提交成功！");
          this.dialogFormVisible = false;
        } else {
          console.log("提交失败！");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getFourData() {
      this.getAction({
        url: noticeInfo.fourData,
      }).then((res) => {
        // console.log(res)
        this.fourObj = res;
      });
    },
    onBaseMore() {
      this.$router.push({
        path: "/Innovation/components/policyCenter",
        query: { type: "双创基地" },
      });
    },
    onActiveryMore() {
      this.$router.push({
        path: "/Innovation/components/consultation",
        query: { type: "资讯公告", activeKey: "3" },
      });
    },
    onActivery(id) {
      this.$router.push({
        path: "/Innovation/components/activeryDetail",
        query: { id: id, type: "资讯公告" },
      });
    },
    onBase(id) {
      this.$router.push({
        path: "/Innovation/components/policyDetail",
        query: { id: id, type: "双创基地" },
      });
    },
    goMore(url, ty) {
      this.$router.push({
        path: url,
        query: { type: ty },
      });
    },
    goDcwj() {
      this.dialogFormVisible = true;
      this.questionList = [];
      this.getSheetList();
    },

    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl);
    },
    // 活动报名
    getSignup() {
      this.getAction({
        url: activity.pageList,
        params: {
          systemType: "innovation",
        },
      }).then((res) => {
        this.activityData = res.records;
      });
    },
    getSheetList() {
      this.getAction({
        url: sheetWeb.pageList,
        params: { key: "SX20251118095137762" },
      }).then((res) => {
        console.log(res, "返回的调查问卷结果");
        this.questionList = res.formVOS || [];
        // 动态生成校验规则
        this.rules = {}; // 清空原有规则
        this.questionList.forEach((question) => {
          // 为每个问题设置唯一字段（用问题ID）
          const field = `question_${question.id}`;
          // 初始化答案字段
          this.ruleForm[field] = question.type === "checkbox" ? [] : "";

          // 根据问题类型设置校验规则（必填）
          this.rules[field] = [
            {
              required: true,
              message: `请回答第${this.questionList.indexOf(question) + 1}题`,
              trigger: "change",
              // 多选框需要指定类型为array
              type: question.type === "checkbox" ? "array" : "string",
            },
          ];
        });
      });
    },
    //双创数据
    getGather() {
      this.getAction({
        url: base.gather,
      }).then((res) => {
        this.scData = [
          {
            key: 1,
            title: "国家级科技企业孵化器",
            count: res.nationalTechnologyEnterpriseIncubatorCount,
          },
          {
            key: 2,
            title: "国家备案众创空间",
            count: res.nationalRecordedTotalCreativeSpaces,
          },
          {
            key: 3,
            title: "省级双创基地",
            count: res.provincialTotalDoubleCreationBases,
          },
        ];
      });
    },
    //基地
    getList() {
      this.getAction({
        url: base.pageList,
      }).then((res) => {
        let arr = [...res.records];
        arr.map((item) => {
          item.pic = item.baseImage ? item.baseImage.split(",")[0] : "";
        });
        this.scDataInfoAll = arr;
        this.scDataInfo = this.getRandomArrayElements(arr, 8);
      });
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: "innovation" },
      }).then((res) => {
        this.bannerData = res.records.reverse();
      });
    },
    getPolicyList() {
      this.getAction({
        url: policyWeb.pageList,
        params: { systemType: "innovation" },
      }).then((res) => {
        console.log(res, "res");
        this.policyData = res.records;
      });
    },
    getNoticeData() {
      this.getAction({
        url: noticeWeb.pageList,
        params: { systemType: "innovation" },
      }).then((res) => {
        this.noticeData = res.records;
      });
    },
    //公告详情
    noticeDetail(id) {
      this.$router.push({
        path: "/Innovation/components/noticeDetail",
        query: { id: id, type: "资讯公告" },
      });
    },

    //政策详情
    onpolicyDetail(id) {
      this.$router.push({
        path: "/Innovation/components/announcement",
        query: { id: id, type: "资讯公告" },
      });
    },
    getRandomArrayElements(arr, count) {
      let shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
  },
  watch: {
    scDataInfo(newValue) {
      if (newValue) {
        const ele = document.getElementById("scDataContent"); // 动效所在元素的DOM
        ele.className = ele.className.replace(" animate__fadeIn", ""); // 先删除动效类名
        setTimeout(() => {
          ele.className += " animate__fadeIn"; // 然后再设置延迟增加动效类名
        }, 50);
        setTimeout(() => {
          this.scDataInfo = this.getRandomArrayElements(this.scDataInfoAll, 8);
        }, 10000);
      }
    },
  },
};
</script>

<style scoped lang="less">
.smallHeaderBox {
  overflow: hidden;
  width: 100%;
  background-color: #ecf0f6;
  color: #666666;
  font-size: 14px;
  padding: 10px 0;

  .smallHeader {
    float: left;
  }

  .backhome {
    float: right;
    cursor: pointer;
    color: #1890ff;
  }
}

.headerBox {
  width: 100%;
  height: 92px;
  background-color: #fff;

  .hearderContentBox {
    width: 1200px;
    margin: 0 auto;

    .titleBox {
      float: left;
      line-height: 92px;
      font-size: 30px;
      font-weight: bold;
    }

    .rightBox {
      float: right;
      margin-top: 2.5%;
    }
  }
}

.menuTopBox {
  margin: 0 auto;
  width: 1200px;
  background-color: #fff;

  .menuTopContent {
    margin: 0 auto;

    :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item) {
      width: 10%;
      text-align: center;
    }

    .floatRight {
      float: right;
      margin-top: -36px;
      width: 29%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }
}

.bannerBox {
  position: relative;
  width: 100%;

  :deep(.ant-carousel) {
    position: relative;
    width: 100%;
  }

  .bannerImg {
    width: 100%;
    height: 282px;

    img {
      width: 100%;
      object-fit: cover;
      height: 280px;
    }
  }
}

.notice {
  width: 1200px;
  margin: 10px auto;

  .box {
    display: flex;
    justify-content: space-between;
  }
}

:deep(.ant-divider-vertical) {
  top: 0.05em;
  height: 1.8em;
}

.cardBox {
  position: relative;
  overflow: hidden;
  width: 1200px;
  margin: -24px auto 60px auto;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 5px 1px #999;

  .smallCardBox {
    position: relative;
    width: 100%;
    margin: 36px auto 24px auto;
    height: 46px;

    .leftImg {
      float: left;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      background-color: #ccc;
    }

    .rightText {
      float: left;
      margin-left: 5px;
      line-height: 46px;

      span {
        font-size: 24px;
        color: #0048c4;
      }
    }
  }
}

.contentBox {
  margin: 40px auto 20px auto;
  width: 1200px;
  height: auto;

  .menuBox {
    text-align: center;
    font-size: 42px;
  }
}

.scDataBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  // background-color: #0048c4;
  .scDataTitle {
    font-size: 42px;
    text-align: center;
  }

  .scDataSmallTitle {
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;

    .scDataSmallCont {
      margin-bottom: 20px;
      width: 25%;
      text-align: center;
      border-right: 1px solid #f1f1f1;

      .contNum {
        color: #fc550b;
        font-size: 40px;
        user-select: none;
      }

      .contTitle {
        font-size: 14px;
        color: #999;
      }
    }

    .scDataSmallCont:nth-child(5) {
      border-right: none;
    }
  }

  .industrialContentBox {
    margin-bottom: 40px;
    overflow: hidden;

    .industrialContent {
      overflow: hidden;
      width: 100%;

      .industrialContentLeft {
        float: left;
        width: 55%;
        height: 370px;

        .lef {
          display: none !important;
          background-image: url("../../assets/img/jianlef.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          z-index: 1;
          width: 2rem;
          left: 0;
          height: 2rem;
          border-radius: 50%;
        }

        .lef:hover {
          background-image: url("../../assets/img/jianlefh.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          z-index: 1;
          border-radius: 50%;
        }

        .rig {
          display: none !important;
          background-image: url("../../assets/img/jianrig.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          z-index: 1;
          width: 2rem;
          right: 0;
          height: 2rem;
          border-radius: 50%;
        }

        .rig:hover {
          background-image: url("../../assets/img/jianrigh.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          z-index: 1;
          border-radius: 50%;
        }

        .imgBox {
          cursor: pointer;
          width: 35%;
          height: 370px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .industrialContentLeft:hover {
        .lef {
          display: block !important;
        }

        .rig {
          display: block !important;
        }
      }

      .industrialContentRight {
        position: relative;
        // overflow: hidden;
        float: right;
        width: 43%;
        color: #333;
        height: 226px;

        .industrialTitleBox {
          overflow: hidden;
          width: 100%;
          border-bottom: 1px solid #dedede;

          .industrialTitle {
            float: left;
            font-size: 20px;
            color: #333;
            padding-bottom: 5px;
          }

          .industrialTitle::before {
            content: "";
            padding-left: 12px;
            border-left: 4px solid #fc550b;
          }

          .MoreBox {
            float: right;
            color: #999;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .industrialContentTitle {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
        }

        .industrialContentDesc {
          margin: 8px 0;
          font-size: 18px;
        }

        .industrialContentInfo {
          margin: 8px 0 40px 0;
          font-size: 14px;
          color: #666;
        }

        .industrialContentBtn {
          width: 120px;
          height: 35px;
          z-index: 999;

          .btn {
            width: 100%;
            height: 100%;
          }
        }

        :deep(.ant-list-lg .ant-list-item) {
          padding: 16px 0;
          cursor: pointer;
        }

        .left {
          width: 84%;
          float: left;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }

        .right {
          float: right;
        }

        a {
          color: #000;
        }

        .ant-list-item:hover {
          color: #0a2c83;
        }

        .ant-list-item .right:hover {
          color: #0a2c83;
        }
      }
    }
  }
}

#scDataContent {
  overflow: hidden;
  margin: 20px 0;
  transition: all 1.5s;

  .bigBoxBBBB {
    width: 100%;

    .smallItem {
      overflow: hidden;
      position: relative;
      float: left;
      width: 25%;
      height: 300px;
      cursor: pointer;

      .baseName {
        width: 100%;
        height: 120px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 30px;
        color: #fff;
        opacity: 0;
        z-index: 111;
        transition: all 1.5s;
        transform: translateY(150px);
      }

      .maskB {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;
        background-color: #000;
        opacity: 0;
        transition: all 1.5s;
      }

      img {
        transition: all 1.5s;
      }

      .baseNameBottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 24px;
        line-height: 24px;
        font-size: 18px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 1.5s;
        opacity: 1;
      }
    }

    .smallItem:hover {
      img {
        transform: scale(1.2);
        transform-origin: center;
      }

      .baseName {
        opacity: 1;
        transform: translateY(36px);
      }

      .maskB {
        opacity: 0.2;
      }

      .baseNameBottom {
        opacity: 0;
      }
    }
  }

  :deep(.slick-slide) {
    width: 100% !important;
  }

  :deep(.ant-carousel .slick-dots li) {
    width: 10px;
    height: 10px;
    border-radius: 50%;

    button {
      height: 10px;
      border-radius: 50%;
    }
  }

  .carousel-list {
    .slick-slider {
      .slick-list {
        width: 95%;
        margin: 0 auto;
      }
    }
  }

  .ant-carousel :deep(.slick-slide) {
    text-align: center;
    background: #fff;
    overflow: hidden;
  }

  .ant-carousel :deep(.slick-arrow.custom-slick-arrow) {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    z-index: 1;
    border-radius: 50%;
  }

  .ant-carousel :deep(.custom-slick-arrow:before) {
    display: none;
  }

  .ant-carousel :deep(.slick-slide h3) {
    color: #fff;
  }

  .carousel-list {
    cursor: pointer;
  }
}

.lookBtn {
  width: 180px;
  margin: 30px auto !important;

  .btn {
    width: 100%;
    height: 54px;
    margin: 20px auto;
  }
}

.activityBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  .activityTitle {
    font-size: 42px;
    text-align: center;
  }

  .activityContent {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .activityLi {
      width: 23%;
      margin: 20px 32px 20px 0;
      cursor: pointer;
      border: 1px solid #dedede;

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 10px;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:nth-child(4n) {
      margin-right: 0;
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;
      border: none;
      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}

.pointsBox {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 55px 0;

  .pointsTitle {
    padding: 0 0 20px 0;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }

  .pointsSmallBox {
    display: flex;
    justify-content: space-between;

    .leftList {
      width: 49%;

      .moreList {
        float: right;
        margin-top: -21px;
      }

      .moreList:hover {
        color: #0a2c83;
        cursor: pointer;
      }

      .left {
        float: left;
      }

      .right {
        float: right;
      }

      a {
        color: #000;
      }

      .ant-list-item a:hover {
        color: #0a2c83;
      }

      .ant-list-item .right:hover {
        color: #0a2c83;
      }
    }

    .rightPic {
      position: relative;
      padding: 45px;
      width: 49%;

      .rightTitle {
        position: relative;
        z-index: 1;
        font-size: 40px;
        color: #fff;
        font-weight: bold;
      }

      .rightInfo {
        position: relative;
        z-index: 1;
        padding-top: 15px;
        line-height: 25px;
        width: 64%;
        color: #fff;
      }

      .rightForm {
        position: relative;
        z-index: 1;
        margin-top: 30px;
      }

      .picImg {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.foot {
  background: #333333;
  color: #999999;
  padding-top: 20px;
  margin-bottom: -10px;

  span {
    cursor: pointer;
    padding: 0 20px;
    font-size: 16px;

    &:nth-child(1) {
      padding-left: 0;
    }

    &:hover {
      text-shadow: 1px 1px 1px #ffffff;
    }
  }
}

.suevey-div {
  width: 100%;
  background: #f0f2f5;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.suevey-content {
  width: 800px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 30px 40px;
}

.survey-title {
  color: #303133;
  font-size: 20px;
  text-align: center;
  font-weight: 600;
  color: rgb(14, 155, 210);
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.form-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.form-item {
  margin-bottom: 30px;
  width: 100%;
}

.form-label {
  display: block;
  margin-bottom: 15px;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 27px;
  width: 100%;
  padding: 5px 0;
}

.radio-item {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

/* 复选框组样式优化 */
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 30px;
  width: 100%;
  padding: 5px 0;
}

/* 提交按钮居中核心样式 */
.submit-button-group {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee; /* 添加上边框分隔 */
}
::v-deep(.el-dialog) {
  margin-top: 30px !important; // 可根据需要调整数值，数值越小离顶部越近
}
/* 按钮样式优化 */
::v-deep .el-button--primary {
  padding: 8px 30px; /* 适当加大按钮尺寸 */
  font-size: 15px;
  margin: 0 auto;
}

/* 修复表单项内容布局 */
::v-deep .el-form-item__content {
  display: flex;
  flex-wrap: wrap;
  line-height: 32px;
}
</style>
